var map = {
	"./ankeri_a.png": 82225,
	"./ankeri_logo.png": 30447,
	"./csm_logo.jpeg": 95041,
	"./dnv_logo.png": 40597,
	"./emission_plus.png": 39883,
	"./hanseaticsoft_logo.png": 83031,
	"./hoppe.png": 22971,
	"./inmarsat.png": 35470,
	"./klappir_logo.jpeg": 70193,
	"./kongsberg_logo.png": 89065,
	"./mac_system_solutions.png": 27629,
	"./marorka.jpeg": 68533,
	"./navigator_insight.png": 38169,
	"./navis.png": 36820,
	"./oceansync_logo.png": 56104,
	"./onelink.png": 37759,
	"./seacotec.png": 70854,
	"./sertica.png": 4292,
	"./spire.jpeg": 77371,
	"./stormgeo.png": 75033,
	"./veracity.png": 87482,
	"./vessel_tracker.png": 30088
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57875;